import OpacityOutlinedIcon from '@mui/icons-material/OpacityOutlined';

/**
 * Tipo de pele de Baumann: quatro eixos independentes (oleosa ou seca,
 * sensível ou resistente, pigmentada ou não pigmentada, enrugada ou firme),
 * que juntos formam um dos 16 tipos, escrito com 4 letras (ex.: OSPW).
 * Referência clínica: Baumann L, "Understanding and treating various skin
 * types: the Baumann Skin Type Indicator", Dermatol Clin 2008;26:359-73.
 * O questionário (BSTI) não é reproduzido: aqui se registra o resultado de
 * cada eixo. Textos nossos.
 *
 * As letras são as da autora, em inglês (O/D, S/R, P/N, W/T): o código fica
 * igual ao da literatura. Os valores precisam ser os mesmos de
 * public/api/scales/catalog/baumann.php.
 */
const baumann = {
  key: 'baumann',
  name: 'Tipo de pele de Baumann',
  description: 'Os 4 eixos da pele e o tipo em 4 letras, como OSPW',
  details: 'Classifica a pele em quatro eixos: oleosa ou seca, sensível ou resistente, pigmentada ou não pigmentada, enrugada ou firme. Com os quatro marcados, o card mostra o tipo em 4 letras (um dos 16 tipos de Baumann, como OSPW ou DRNT), que orienta a escolha de ativos e de rotina de cuidados. Registre o resultado da avaliação ou do questionário; o card mostra o tipo da última consulta e a aba Saúde guarda a evolução.',
  kind: 'fields',
  icon: OpacityOutlinedIcon,
  accent: 'pink',
  code: { label: 'Tipo de Baumann' },
  fields: [
    {
      key: 'oiliness',
      label: 'Oleosidade',
      options: [
        { value: 'O', label: 'Oleosa', caption: 'O', help: 'Produz sebo em excesso: brilho ao longo do dia e poros aparentes.' },
        { value: 'D', label: 'Seca', caption: 'D', help: 'Pouco sebo e barreira frágil: repuxa, descama e perde água com facilidade.' },
      ],
    },
    {
      key: 'sensitivity',
      label: 'Sensibilidade',
      options: [
        { value: 'S', label: 'Sensível', caption: 'S', help: 'Reage com vermelhidão, ardor, coceira ou acne a produtos e ao ambiente.' },
        { value: 'R', label: 'Resistente', caption: 'R', help: 'Barreira forte: tolera bem a maior parte dos produtos, com pouca reação.' },
      ],
    },
    {
      key: 'pigmentation',
      label: 'Pigmentação',
      options: [
        { value: 'P', label: 'Pigmentada', caption: 'P', help: 'Tende a manchar: melasma, sardas ou manchas depois de inflamação.' },
        { value: 'N', label: 'Não pigmentada', caption: 'N', help: 'Tom uniforme, sem tendência a manchas.' },
      ],
    },
    {
      key: 'aging',
      label: 'Rugas',
      options: [
        { value: 'W', label: 'Enrugada', caption: 'W', help: 'Rugas e perda de firmeza, ou hábitos de risco, como sol sem proteção e tabagismo.' },
        { value: 'T', label: 'Firme', caption: 'T', help: 'Pele firme, sem rugas relevantes para a idade.' },
      ],
    },
  ],
};

export default baumann;
